import React from "react";
import * as styles from "./filter-alphabetised-section.css";

interface FilterAlphabetisedSectionProps {
    title?: string;
    divider?: boolean;
    children: React.ReactNode;
}

export function FilterAlphabetisedSection({
    children,
    title,
}: FilterAlphabetisedSectionProps): JSX.Element {
    return (
        <div role="menu" className={styles.container}>
            <div className={styles.title}>{title}</div>
            <div className={styles.content}>{children}</div>
        </div>
    );
}
